import { ReactNode, CSSProperties } from 'react';

export interface CardProps {
  children: ReactNode;
  className?: string;
  style?: CSSProperties;
}

export function Card({ children, className = '', style }: CardProps) {
  return (
    <div className={`ds-card ${className}`.trim()} style={style}>
      {children}
    </div>
  );
}

export interface CardHeaderProps {
  title?: ReactNode;
  caption?: ReactNode;
  actions?: ReactNode;
  children?: ReactNode;
  className?: string;
}

export function CardHeader({ title, caption, actions, children, className = '' }: CardHeaderProps) {
  if (children) {
    return <div className={`ds-card-h ${className}`.trim()}>{children}</div>;
  }
  return (
    <div className={`ds-card-h ${className}`.trim()}>
      <div>
        {title ? <div className="ds-card-title">{title}</div> : null}
        {caption ? <div className="ds-card-caption">{caption}</div> : null}
      </div>
      {actions ? <div className="ds-card-actions">{actions}</div> : null}
    </div>
  );
}

export function CardBody({
  children,
  className = '',
  style,
}: {
  children: ReactNode;
  className?: string;
  style?: CSSProperties;
}) {
  return (
    <div className={`ds-card-b ${className}`.trim()} style={style}>
      {children}
    </div>
  );
}

export function CardDivider() {
  return <div className="ds-card-divider" aria-hidden="true" />;
}

export default Card;
